export const translations = {
  fr: {
    welcome: "Bienvenue sur PartyFlow.ch",
    subtitle: "Système de comptage en temps réel",
    login: "Connexion",
    emailOrUsername: "Email ou nom d'utilisateur",
    password: "Mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    resetPassword: "Réinitialiser le mot de passe",
    resetSent: "Email de réinitialisation envoyé",
    resetDesc: "Entrez votre email pour recevoir un lien de réinitialisation",
    send: "Envoyer",
    back: "Retour",
    email: "Email",
    present: "Présents",
    in: "Entrée",
    out: "Sortie",
    stats: "Statistiques",
    maxPeak: "Max instantané",
    totalIn: "Total entrées",
    totalOut: "Total sorties",
    since: "Depuis",
    export: "Exporter",
    exportCSV: "CSV",
    exportXLS: "XLS",
    reset: "Réinitialiser",
    resetConfirm: "Êtes-vous sûr ? Toutes les données de cet événement seront supprimées.",
    resetWarning: "Cette action est irréversible. Tout repart à zéro.",
    confirmFinal: "Oui, tout effacer",
    resetSuccess: "Données réinitialisées",
    confirmPassword: "Confirmer avec mot de passe",
    confirm: "Confirmer",
    cancel: "Annuler",
    logout: "Déconnexion",
    eventTitle: "Titre de l'événement",
    eventDate: "Date de l'événement",
    settings: "Paramètres",
    save: "Enregistrer",
    uploadLogo: "Télécharger un logo",
    evolution: "Évolution",
    invalidCredentials: "Identifiants invalides",
    language: "Langue",
    start: "Démarrer l'événement",
    stop: "Arrêter le comptage",
    endPartyConfirm: "Fin de soirée ? Sûr ?",
    summaryTitle: "Récapitulatif",
    duration: "Durée",
    newEvent: "Nouvel événement",
    resume: "Reprendre",
    heroTitle: "Comptez vos participants en temps réel",
    heroDesc: "PartyFlow.ch est un outil simple et efficace pour suivre le nombre de personnes présentes lors de vos événements : soirées, festivals, salons, conférences…",
    heroCta: "Commencer maintenant",
    whatTitle: "À quoi ça sert ?",
    whatDesc: "PartyFlow.ch vous aide à garder le contrôle sur la jauge de votre événement, en toute simplicité.",
    feat1Title: "Comptage en direct",
    feat1Desc: "Suivez les entrées et sorties en temps réel depuis votre téléphone.",
    feat2Title: "Statistiques claires",
    feat2Desc: "Visualisez le pic de fréquentation, les totaux et l'évolution dans le temps.",
    feat3Title: "Simple et rapide",
    feat3Desc: "Aucune installation. Connectez-vous et commencez à compter en quelques secondes.",
    howTitle: "Comment ça marche ?",
    howStep1: "Créez votre compte gratuitement.",
    howStep2: "Configurez votre événement (titre, date, logo).",
    howStep3: "Lancez le comptage et partagez l'accès via un lien unique pour les fonctions de base.",
    howStep4: "Consultez les statistiques pour analyser votre événement.",
    freeTitle: "C'est gratuit !",
    freeDesc: "PartyFlow.ch est actuellement en phase de lancement. Profitez de toutes les fonctionnalités gratuitement, sans engagement ni carte bancaire.",
    feedbackTitle: "Aidez-nous à progresser",
    feedbackDesc: "Vos retours sont précieux ! Faites-nous parvenir vos remarques, suggestions ou signalements de bugs pour améliorer le produit.",
    contactTitle: "Contact",
    contactDesc: "Une question, une idée, un partenariat ? Écrivez-nous.",
    footerText: "Tous droits réservés",
    welcomeUser: "Bienvenue",
    createEvent: "Créer un événement",
    eventName: "Nom de l'événement *",
    eventNamePlaceholder: "Ma super soirée",
    date: "Date",
    logo: "Logo",
    create: "Créer",
    running: "En cours",
    notStarted: "Pas encore démarré",
    ended: "Terminé",
    deleteEvent: "Supprimer l'événement ?",
    deleteEventDesc: "Ceci supprimera définitivement \"{name}\" et toutes ses données. Cette action est irréversible.",
    delete: "Supprimer",
    eventCreated: "Événement créé ✓",
    errorCreating: "Erreur lors de la création",
    eventDeleted: "Événement supprimé",
    errorDeleting: "Erreur lors de la suppression",
    noEventsYet: "Aucun événement. Créez le premier !",
    untitled: "Sans titre",
    signup: "S'inscrire",
    username: "Nom d'utilisateur",
    passwordMin: "Mot de passe (min 6 caractères)",
    noAccount: "Pas de compte ?",
    hasAccount: "Déjà un compte ?",
    usernameTaken: "Ce nom d'utilisateur est déjà pris",
    accountCreated: "Compte créé ! Vérifiez votre email pour confirmer.",
    errorAccount: "Erreur lors de la création du compte",
    adminOnly: "Accès réservé aux administrateurs",
    adminUsers: "Gestion des utilisateurs",
    adminTotalUsers: "utilisateurs",
    adminEvents: "événements",
    adminNewUsers: "Nouveaux comptes",
    adminNewEvents: "Nouveaux events",
    adminDeleteUser: "Supprimer cet utilisateur ?",
    adminDeleteUserDesc: "Ceci supprimera définitivement le compte de \"{name}\" ainsi que toutes ses données (événements, comptages, etc.). Cette action est irréversible.",
    adminUserDeleted: "Utilisateur supprimé",
    archivedEvents: "Événements archivés",
    eventRestored: "Événement restauré",
    restore: "Restaurer",
    // Landing page
    landingSlogan1: "Parce que « ouais, ça devrait jouer » n'est pas un comptage officiel accepté par les autorités.",
    landingSlogan2: "Entrée, sortie, entrée, sortie, entrée, … — on traque les indécis pour que tu n'aies pas à le faire.",
    landingSlogan3: "Pour les soirées où la moitié des invités hésitent à rester et l'autre moitié dépasse la capacité.",
    landingSlogan4: "Parce que rien ne ruine plus l'ambiance que de réaliser qu'il y a plus de monde que de sorties…",
    landingSlogan5: "Un comptage en temps réel pour que la fête reste safe plutôt qu'elle ne devienne une soirée dont tout le monde se souvient pour les mauvaises raisons.",
    landingSlogan6: "Pour suivre le crétin qui n'arrête pas de rentrer et sortir comme si l'endroit lui appartenait.",
    landingGetStarted: "Commencer maintenant",
    landingHero: "Comptez vos participants en temps réel",
    landingWhatTitle: "À quoi ça sert ?",
    landingWhatDesc: "PartyFlow vous aide à garder le contrôle sur la jauge de votre événement, en toute simplicité.",
    landingFeat1Title: "Comptage en direct",
    landingFeat1Desc: "Suivez les entrées et sorties en temps réel depuis votre téléphone.",
    landingFeat2Title: "Statistiques claires",
    landingFeat2Desc: "Visualisez le pic de fréquentation, les totaux et l'évolution dans le temps.",
    landingFeat3Title: "Simple et rapide",
    landingFeat3Desc: "Aucune installation. Connectez-vous et commencez à compter en quelques secondes.",
    landingHowTitle: "Comment ça marche ?",
    landingHow1: "Créez votre compte gratuitement.",
    landingHow2: "Configurez votre événement (titre, date, logo).",
    landingHow3: "Lancez le comptage et partagez l'accès via un lien unique pour les fonctions de base.",
    landingHow4: "Consultez les statistiques pour analyser votre événement.",
    landingFreeTitle: "C'est gratuit !",
    landingFreeDesc: "PartyFlow est actuellement en phase de lancement. Profitez de toutes les fonctionnalités gratuitement, sans engagement ni carte bancaire.",
    landingFeedbackTitle: "Aidez-nous à progresser",
    landingFeedbackDesc: "Vos retours sont précieux ! Faites-nous parvenir vos remarques, suggestions ou signalements de bugs.",
    feedbackName: "Nom",
    feedbackEmail: "Email",
    feedbackMessage: "Remarque",
    feedbackSend: "Envoyer",
    feedbackSuccess: "Merci pour votre message !",
    feedbackError: "Erreur lors de l'envoi. Réessayez plus tard.",
    landingFooter: "Tous droits réservés",
    // Disclaimer
    disclaimerTitle: "Conditions Generales d'Utilisation",
    disclaimerIntro: "En accedant au service PartyFlow.ch et en creant un compte, l'utilisateur accepte sans reserve les presentes conditions generales d'utilisation.",
    disclaimerBeta: "Art. 1 — Objet et nature du service. PartyFlow.ch est une application de comptage numerique en phase de developpement (version beta). Le service est fourni en l'etat, sans aucune garantie expresse ou implicite quant a sa disponibilite, sa fiabilite, son exactitude ou son adequation a un usage particulier.",
    disclaimerNature: "Art. 2 — Limitations techniques. Le service repose sur des technologies connectees a Internet (serveurs distants, bases de donnees, reseaux mobiles). Son fonctionnement peut etre affecte a tout moment par des interruptions, des latences, des pannes materielles ou logicielles, ou des facteurs echappant au controle de l'exploitant.",
    disclaimerLiability: "Art. 3 — Exclusion de responsabilite. Dans les limites autorisees par le droit suisse, l'exploitant de PartyFlow.ch exclut toute responsabilite pour :",
    disclaimerLiabilityItems: "Toute perte, alteration ou inexactitude des donnees enregistrees via le service|Toute indisponibilite, temporaire ou definitive, du service ou de l'un de ses composants|Tout dommage direct, indirect, materiel ou immateriel resultant de l'utilisation ou de l'impossibilite d'utiliser le service|Toute consequence liee a une defaillance reseau, serveur, ou a un dysfonctionnement logiciel",
    disclaimerRisk: "Art. 4 — Acceptation des risques. L'utilisateur reconnait que le service ne saurait se substituer a un dispositif de comptage certifie ou homologue. Il lui appartient de mettre en place tout systeme de secours qu'il juge necessaire pour les evenements a enjeu critique.",
    disclaimerPrivacy: "Art. 5 — Protection des donnees. Le traitement des donnees personnelles est effectue conformement a la Loi federale sur la protection des donnees (LPD, RS 235.1). Seules les donnees strictement necessaires au fonctionnement du service sont collectees. L'utilisateur peut demander la suppression de son compte et de l'ensemble de ses donnees a tout moment.",
    disclaimerLaw: "Art. 6 — Droit applicable et for juridique. Les presentes conditions sont exclusivement soumises au droit suisse. Tout litige sera porte devant les tribunaux competents en Suisse.",
    disclaimerAccept: "Je reconnais avoir lu et accepte les conditions generales d'utilisation de PartyFlow.ch.",
    disclaimerAcceptBtn: "Accepter et continuer",
    // Onboarding
    onboardingPlus: "Appuyez ici pour compter une entrée.",
    onboardingMinus: "Appuyez ici pour compter une sortie.",
    onboardingReset: "Réinitialise le compteur et efface toutes les données.",
    onboardingExport: "Exportez vos données en CSV ou XLS.",
    onboardingStaffLink: "Copiez ce lien et partagez-le avec votre équipe pour qu'ils puissent compter sans avoir de compte.",
    onboardingNext: "Suivant",
    onboardingDone: "C'est parti !",
    // Social & phone auth
    orContinueWith: "Ou continuer avec",
    phone: "Téléphone",
    phoneNumber: "Numéro de téléphone",
    sendCode: "Envoyer le code",
    verifyCode: "Vérifier le code",
    otpCode: "Code de vérification",
    otpSent: "Code envoyé par SMS",
    otpError: "Erreur lors de l'envoi du code",
    otpInvalid: "Code invalide",
    continueWithGoogle: "Continuer avec Google",
    continueWithApple: "Continuer avec Apple",
    // Offline
    offlineBanner: "Vous êtes hors ligne",
    offlineBannerDesc: "Les données sont sauvegardées localement",
    backOnline: "Connexion rétablie",
    syncing: "Synchronisation en cours…",
    syncComplete: "Données synchronisées ✓",
    syncError: "Erreur de synchronisation",
    pendingEntries: "entrées en attente",
    updateAvailable: "Nouvelle version disponible",
    updateNow: "Mettre à jour",
  },
  de: {
    welcome: "Willkommen bei PartyFlow.ch",
    subtitle: "Echtzeit-Zählsystem",
    login: "Anmelden",
    emailOrUsername: "E-Mail oder Benutzername",
    password: "Passwort",
    forgotPassword: "Passwort vergessen?",
    resetPassword: "Passwort zurücksetzen",
    resetSent: "Zurücksetzungs-E-Mail gesendet",
    resetDesc: "Geben Sie Ihre E-Mail ein, um einen Zurücksetzungslink zu erhalten",
    send: "Senden",
    back: "Zurück",
    email: "E-Mail",
    present: "Anwesend",
    in: "Eingang",
    out: "Ausgang",
    stats: "Statistiken",
    maxPeak: "Max Momentan",
    totalIn: "Gesamt Eingänge",
    totalOut: "Gesamt Ausgänge",
    since: "Seit",
    export: "Exportieren",
    exportCSV: "CSV",
    exportXLS: "XLS",
    reset: "Zurücksetzen",
    resetConfirm: "Sind Sie sicher? Alle Daten dieses Events werden gelöscht.",
    resetWarning: "Diese Aktion kann nicht rückgängig gemacht werden. Alles wird auf Null gesetzt.",
    confirmFinal: "Ja, alles löschen",
    resetSuccess: "Daten zurückgesetzt",
    confirmPassword: "Mit Passwort bestätigen",
    confirm: "Bestätigen",
    cancel: "Abbrechen",
    logout: "Abmelden",
    eventTitle: "Veranstaltungstitel",
    eventDate: "Veranstaltungsdatum",
    settings: "Einstellungen",
    save: "Speichern",
    uploadLogo: "Logo hochladen",
    evolution: "Entwicklung",
    invalidCredentials: "Ungültige Anmeldedaten",
    language: "Sprache",
    start: "Veranstaltung starten",
    stop: "Zählung stoppen",
    endPartyConfirm: "Ende der Veranstaltung? Sicher?",
    summaryTitle: "Zusammenfassung",
    duration: "Dauer",
    newEvent: "Neue Veranstaltung",
    resume: "Fortsetzen",
    heroTitle: "Zählen Sie Ihre Teilnehmer in Echtzeit",
    heroDesc: "PartyFlow.ch ist ein einfaches Tool zur Echtzeit-Erfassung der Personenanzahl bei Ihren Events.",
    heroCta: "Jetzt starten",
    whatTitle: "Wofür ist das?",
    whatDesc: "PartyFlow.ch hilft Ihnen, die Kapazität Ihres Events einfach im Blick zu behalten.",
    feat1Title: "Live-Zählung",
    feat1Desc: "Verfolgen Sie Ein- und Ausgänge in Echtzeit von Ihrem Handy.",
    feat2Title: "Klare Statistiken",
    feat2Desc: "Sehen Sie Spitzenwerte, Gesamtzahlen und den Zeitverlauf.",
    feat3Title: "Einfach & schnell",
    feat3Desc: "Keine Installation nötig. Anmelden und in Sekunden loszählen.",
    howTitle: "Wie funktioniert es?",
    howStep1: "Erstellen Sie kostenlos ein Konto.",
    howStep2: "Konfigurieren Sie Ihr Event (Titel, Datum, Logo).",
    howStep3: "Starten Sie die Zählung und teilen Sie den Zugang über einen einzigartigen Link für die Grundfunktionen.",
    howStep4: "Sehen Sie sich die Statistiken an, um Ihr Event zu analysieren.",
    freeTitle: "Es ist kostenlos!",
    freeDesc: "PartyFlow.ch befindet sich in der Startphase. Nutzen Sie alle Funktionen kostenlos, ohne Verpflichtung.",
    feedbackTitle: "Helfen Sie uns, besser zu werden",
    feedbackDesc: "Ihr Feedback ist wertvoll! Senden Sie uns Ihre Anmerkungen, Vorschläge oder Fehlermeldungen.",
    contactTitle: "Kontakt",
    contactDesc: "Eine Frage, eine Idee, eine Partnerschaft? Schreiben Sie uns.",
    footerText: "Alle Rechte vorbehalten",
    welcomeUser: "Willkommen",
    createEvent: "Veranstaltung erstellen",
    eventName: "Veranstaltungsname *",
    eventNamePlaceholder: "Meine tolle Party",
    date: "Datum",
    logo: "Logo",
    create: "Erstellen",
    running: "Laufend",
    notStarted: "Noch nicht gestartet",
    ended: "Beendet",
    deleteEvent: "Veranstaltung löschen?",
    deleteEventDesc: "Dies löscht \"{name}\" und alle Daten dauerhaft. Diese Aktion kann nicht rückgängig gemacht werden.",
    delete: "Löschen",
    eventCreated: "Veranstaltung erstellt ✓",
    errorCreating: "Fehler beim Erstellen",
    eventDeleted: "Veranstaltung gelöscht",
    errorDeleting: "Fehler beim Löschen",
    noEventsYet: "Noch keine Veranstaltungen. Erstellen Sie Ihre erste!",
    untitled: "Ohne Titel",
    signup: "Registrieren",
    username: "Benutzername",
    passwordMin: "Passwort (mind. 6 Zeichen)",
    noAccount: "Noch kein Konto?",
    hasAccount: "Bereits ein Konto?",
    usernameTaken: "Dieser Benutzername ist bereits vergeben",
    accountCreated: "Konto erstellt! Überprüfen Sie Ihre E-Mail zur Bestätigung.",
    errorAccount: "Fehler beim Erstellen des Kontos",
    adminOnly: "Nur für Administratoren",
    adminUsers: "Benutzerverwaltung",
    adminTotalUsers: "Benutzer",
    adminEvents: "Veranstaltungen",
    adminNewUsers: "Neue Konten",
    adminNewEvents: "Neue Events",
    adminDeleteUser: "Benutzer löschen?",
    adminDeleteUserDesc: "Dies löscht das Konto von \"{name}\" und alle zugehörigen Daten dauerhaft. Diese Aktion kann nicht rückgängig gemacht werden.",
    adminUserDeleted: "Benutzer gelöscht",
    archivedEvents: "Archivierte Events",
    eventRestored: "Event wiederhergestellt",
    restore: "Wiederherstellen",
    // Landing page
    landingSlogan1: "Weil « ja, das sollte passen » keine offizielle Zählung ist, die von den Behörden akzeptiert wird.",
    landingSlogan2: "Rein, raus, rein, raus, rein, … — wir tracken die Unentschlossenen, damit du es nicht musst.",
    landingSlogan3: "Für Partys, bei denen die Hälfte der Gäste nicht weiss ob sie bleiben soll und die andere Hälfte schon über der Kapazität ist.",
    landingSlogan4: "Weil nichts die Stimmung mehr ruiniert als die Erkenntnis: mehr Leute als Ausgänge…",
    landingSlogan5: "Echtzeit-Headcount, damit die Party safe bleibt statt zur Nacht wird, an die sich alle aus den falschen Gründen erinnern.",
    landingSlogan6: "Um den Idioten zu tracken, der ständig rein und raus geht, als ob ihm der Laden gehört.",
    landingGetStarted: "Jetzt starten",
    landingHero: "Zählen Sie Ihre Teilnehmer in Echtzeit",
    landingWhatTitle: "Wofür ist das?",
    landingWhatDesc: "PartyFlow hilft Ihnen, die Kapazität Ihres Events einfach im Blick zu behalten.",
    landingFeat1Title: "Live-Zählung",
    landingFeat1Desc: "Verfolgen Sie Ein- und Ausgänge in Echtzeit von Ihrem Handy.",
    landingFeat2Title: "Klare Statistiken",
    landingFeat2Desc: "Sehen Sie Spitzenwerte, Gesamtzahlen und den Zeitverlauf.",
    landingFeat3Title: "Einfach & schnell",
    landingFeat3Desc: "Keine Installation nötig. Anmelden und in Sekunden loszählen.",
    landingHowTitle: "Wie funktioniert es?",
    landingHow1: "Erstellen Sie kostenlos ein Konto.",
    landingHow2: "Konfigurieren Sie Ihr Event (Titel, Datum, Logo).",
    landingHow3: "Starten Sie die Zählung und teilen Sie den Zugang über einen einzigartigen Link für die Grundfunktionen.",
    landingHow4: "Sehen Sie sich die Statistiken an, um Ihr Event zu analysieren.",
    landingFreeTitle: "Es ist kostenlos!",
    landingFreeDesc: "PartyFlow befindet sich in der Startphase. Nutzen Sie alle Funktionen kostenlos, ohne Verpflichtung.",
    landingFeedbackTitle: "Helfen Sie uns, besser zu werden",
    landingFeedbackDesc: "Ihr Feedback ist wertvoll! Senden Sie uns Ihre Anmerkungen, Vorschläge oder Fehlermeldungen.",
    feedbackName: "Name",
    feedbackEmail: "E-Mail",
    feedbackMessage: "Anmerkung",
    feedbackSend: "Senden",
    feedbackSuccess: "Vielen Dank für Ihre Nachricht!",
    feedbackError: "Fehler beim Senden. Versuchen Sie es später erneut.",
    landingFooter: "Alle Rechte vorbehalten",
    // Disclaimer
    disclaimerTitle: "Allgemeine Nutzungsbedingungen",
    disclaimerIntro: "Durch den Zugang zu PartyFlow.ch und die Erstellung eines Kontos akzeptiert der Nutzer die vorliegenden Allgemeinen Nutzungsbedingungen vorbehaltlos. Hinweis: Die rechtsverbindliche Fassung dieser Bedingungen ist die franzoesische Version.",
    disclaimerBeta: "Art. 1 — Gegenstand und Art des Dienstes. PartyFlow.ch ist eine digitale Zaehlapplikation in der Entwicklungsphase (Beta-Version). Der Dienst wird ohne ausdrueckliche oder stillschweigende Garantie hinsichtlich Verfuegbarkeit, Zuverlaessigkeit, Genauigkeit oder Eignung fuer einen bestimmten Zweck bereitgestellt.",
    disclaimerNature: "Art. 2 — Technische Einschraenkungen. Der Dienst basiert auf internetverbundenen Technologien (Remote-Server, Datenbanken, Mobilfunknetze). Sein Betrieb kann jederzeit durch Unterbrechungen, Latenzen, Hardware- oder Softwarefehler oder Faktoren ausserhalb der Kontrolle des Betreibers beeintraechtigt werden.",
    disclaimerLiability: "Art. 3 — Haftungsausschluss. Im Rahmen des schweizerischen Rechts schliesst der Betreiber von PartyFlow.ch jede Haftung aus fuer:",
    disclaimerLiabilityItems: "Jeglichen Verlust, jede Veraenderung oder Ungenauigkeit der ueber den Dienst erfassten Daten|Jede voruebergehende oder dauerhafte Nichtverfuegbarkeit des Dienstes oder einer seiner Komponenten|Jeden direkten, indirekten, materiellen oder immateriellen Schaden aus der Nutzung oder der Unmoelichkeit der Nutzung des Dienstes|Jede Folge eines Netzwerk-, Server- oder Softwarefehlers",
    disclaimerRisk: "Art. 4 — Risikouebernahme. Der Nutzer anerkennt, dass der Dienst kein zertifiziertes oder zugelassenes Zaehlsystem ersetzen kann. Es obliegt ihm, fuer kritische Veranstaltungen ein geeignetes Ersatzsystem bereitzustellen.",
    disclaimerPrivacy: "Art. 5 — Datenschutz. Die Verarbeitung personenbezogener Daten erfolgt gemaess dem Bundesgesetz ueber den Datenschutz (DSG, SR 235.1). Es werden ausschliesslich die fuer den Betrieb des Dienstes zwingend erforderlichen Daten erhoben. Der Nutzer kann jederzeit die Loeschung seines Kontos und saemtlicher Daten verlangen.",
    disclaimerLaw: "Art. 6 — Anwendbares Recht und Gerichtsstand. Die vorliegenden Bedingungen unterstehen ausschliesslich dem schweizerischen Recht. Fuer alle Streitigkeiten sind die zustaendigen Gerichte in der Schweiz zustaendig.",
    disclaimerAccept: "Ich erklaere, die Allgemeinen Nutzungsbedingungen von PartyFlow.ch gelesen zu haben und akzeptiere diese.",
    disclaimerAcceptBtn: "Akzeptieren und fortfahren",
    // Onboarding
    onboardingPlus: "Tippen Sie hier, um einen Eingang zu zählen.",
    onboardingMinus: "Tippen Sie hier, um einen Ausgang zu zählen.",
    onboardingReset: "Setzt den Zähler zurück und löscht alle Daten.",
    onboardingExport: "Exportieren Sie Ihre Daten als CSV oder XLS.",
    onboardingStaffLink: "Kopieren Sie diesen Link und teilen Sie ihn mit Ihrem Team, damit sie ohne Konto zählen können.",
    onboardingNext: "Weiter",
    onboardingDone: "Los geht's!",
    orContinueWith: "Oder weiter mit",
    phone: "Telefon",
    phoneNumber: "Telefonnummer",
    sendCode: "Code senden",
    verifyCode: "Code überprüfen",
    otpCode: "Bestätigungscode",
    otpSent: "Code per SMS gesendet",
    otpError: "Fehler beim Senden des Codes",
    otpInvalid: "Ungültiger Code",
    continueWithGoogle: "Weiter mit Google",
    continueWithApple: "Weiter mit Apple",
    offlineBanner: "Sie sind offline",
    offlineBannerDesc: "Daten werden lokal gespeichert",
    backOnline: "Verbindung wiederhergestellt",
    syncing: "Synchronisierung läuft…",
    syncComplete: "Daten synchronisiert ✓",
    syncError: "Synchronisierungsfehler",
    pendingEntries: "ausstehende Einträge",
    updateAvailable: "Neue Version verfügbar",
    updateNow: "Jetzt aktualisieren",
  },
  en: {
    welcome: "Welcome to PartyFlow.ch",
    subtitle: "Real-time counting system",
    login: "Log in",
    emailOrUsername: "Email or username",
    password: "Password",
    forgotPassword: "Forgot password?",
    resetPassword: "Reset password",
    resetSent: "Reset email sent",
    resetDesc: "Enter your email to receive a reset link",
    send: "Send",
    back: "Back",
    email: "Email",
    present: "Present",
    in: "In",
    out: "Out",
    stats: "Statistics",
    maxPeak: "Peak count",
    totalIn: "Total in",
    totalOut: "Total out",
    since: "Since",
    export: "Export",
    exportCSV: "CSV",
    exportXLS: "XLS",
    reset: "Reset",
    resetConfirm: "Are you sure? All data for this event will be deleted.",
    resetWarning: "This action cannot be undone. Everything starts from zero.",
    confirmFinal: "Yes, delete all",
    resetSuccess: "Data reset",
    confirmPassword: "Confirm with password",
    confirm: "Confirm",
    cancel: "Cancel",
    logout: "Log out",
    eventTitle: "Event title",
    eventDate: "Event date",
    settings: "Settings",
    save: "Save",
    uploadLogo: "Upload logo",
    evolution: "Evolution",
    invalidCredentials: "Invalid credentials",
    language: "Language",
    start: "Start event",
    stop: "Stop counting",
    endPartyConfirm: "End of party? Sure?",
    summaryTitle: "Summary",
    duration: "Duration",
    newEvent: "New event",
    resume: "Resume",
    heroTitle: "Count your attendees in real time",
    heroDesc: "PartyFlow.ch is a simple and effective tool to track the number of people at your events: parties, festivals, conferences…",
    heroCta: "Get started now",
    whatTitle: "What is it for?",
    whatDesc: "PartyFlow.ch helps you keep control of your event capacity, with ease.",
    feat1Title: "Live counting",
    feat1Desc: "Track entries and exits in real time from your phone.",
    feat2Title: "Clear statistics",
    feat2Desc: "View peak attendance, totals, and trends over time.",
    feat3Title: "Simple & fast",
    feat3Desc: "No installation. Log in and start counting in seconds.",
    howTitle: "How does it work?",
    howStep1: "Create your free account.",
    howStep2: "Set up your event (title, date, logo).",
    howStep3: "Start counting and share access with a unique link for basic functions.",
    howStep4: "View statistics to analyse your event.",
    freeTitle: "It's free!",
    freeDesc: "PartyFlow.ch is currently in its launch phase. Enjoy all features for free, no commitment or credit card required.",
    feedbackTitle: "Help us improve",
    feedbackDesc: "Your feedback is valuable! Send us your comments, suggestions, or bug reports to help improve the product.",
    contactTitle: "Contact",
    contactDesc: "A question, an idea, a partnership? Write to us.",
    footerText: "All rights reserved",
    welcomeUser: "Welcome",
    createEvent: "Create Event",
    eventName: "Event name *",
    eventNamePlaceholder: "My awesome party",
    date: "Date",
    logo: "Logo",
    create: "Create",
    running: "Running",
    notStarted: "Not Started",
    ended: "Ended",
    deleteEvent: "Delete event?",
    deleteEventDesc: "This will permanently delete \"{name}\" and all its data. This action cannot be undone.",
    delete: "Delete",
    eventCreated: "Event created ✓",
    errorCreating: "Error creating event",
    eventDeleted: "Event deleted",
    errorDeleting: "Error deleting event",
    noEventsYet: "No events yet. Create your first one!",
    untitled: "Untitled",
    signup: "Sign up",
    username: "Username",
    passwordMin: "Password (min 6 characters)",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    usernameTaken: "This username is already taken",
    accountCreated: "Account created! Check your email to confirm.",
    errorAccount: "Error creating account",
    adminOnly: "Admin access only",
    adminUsers: "User Management",
    adminTotalUsers: "users",
    adminEvents: "events",
    adminNewUsers: "New accounts",
    adminNewEvents: "New events",
    adminDeleteUser: "Delete this user?",
    adminDeleteUserDesc: "This will permanently delete \"{name}\"'s account and all their data (events, counts, etc.). This action cannot be undone.",
    adminUserDeleted: "User deleted",
    archivedEvents: "Archived events",
    eventRestored: "Event restored",
    restore: "Restore",
    // Landing page
    landingSlogan1: "Because 'yeah, we should be fine' is not an official headcount accepted by the authorities.",
    landingSlogan2: "In, out, in, out, in, … — we track the indecisive ones so you don't have to.",
    landingSlogan3: "For parties where half the guests can't decide if they're coming or going — and the other half are already over capacity.",
    landingSlogan4: "Because nothing ruins the vibe more than realizing you've got more people than exits…",
    landingSlogan5: "Real-time headcount so the party stays safe instead of becoming the night everyone remembers for the wrong reasons.",
    landingSlogan6: "Tracking every idiot who keeps wandering in and out like they own the place.",
    landingGetStarted: "Get started now",
    landingHero: "Count your attendees in real time",
    landingWhatTitle: "What is it for?",
    landingWhatDesc: "PartyFlow helps you keep control of your event capacity, with ease.",
    landingFeat1Title: "Live counting",
    landingFeat1Desc: "Track entries and exits in real time from your phone.",
    landingFeat2Title: "Clear statistics",
    landingFeat2Desc: "View peak attendance, totals, and trends over time.",
    landingFeat3Title: "Simple & fast",
    landingFeat3Desc: "No installation. Log in and start counting in seconds.",
    landingHowTitle: "How does it work?",
    landingHow1: "Create your free account.",
    landingHow2: "Set up your event (title, date, logo).",
    landingHow3: "Start counting and share access with a unique link for basic functions.",
    landingHow4: "View statistics to analyse your event.",
    landingFreeTitle: "It's free!",
    landingFreeDesc: "PartyFlow is currently in its launch phase. Enjoy all features for free, no commitment or credit card required.",
    landingFeedbackTitle: "Help us improve",
    landingFeedbackDesc: "Your feedback is valuable! Send us your comments, suggestions, or bug reports to help improve the product.",
    feedbackName: "Name",
    feedbackEmail: "Email",
    feedbackMessage: "Comment",
    feedbackSend: "Send",
    feedbackSuccess: "Thank you for your message!",
    feedbackError: "Error sending. Please try again later.",
    landingFooter: "All rights reserved",
    // Disclaimer
    disclaimerTitle: "General Terms of Use",
    disclaimerIntro: "By accessing PartyFlow.ch and creating an account, the user accepts these General Terms of Use without reservation. Note: The legally binding version of these terms is the French version.",
    disclaimerBeta: "Art. 1 — Purpose and nature of the service. PartyFlow.ch is a digital counting application in its development phase (beta version). The service is provided as is, without any express or implied warranty as to its availability, reliability, accuracy, or fitness for a particular purpose.",
    disclaimerNature: "Art. 2 — Technical limitations. The service relies on Internet-connected technologies (remote servers, databases, mobile networks). Its operation may be affected at any time by interruptions, latency, hardware or software failures, or factors beyond the operator's control.",
    disclaimerLiability: "Art. 3 — Disclaimer of liability. To the fullest extent permitted by Swiss law, the operator of PartyFlow.ch excludes all liability for:",
    disclaimerLiabilityItems: "Any loss, alteration, or inaccuracy of data recorded through the service|Any temporary or permanent unavailability of the service or any of its components|Any direct, indirect, material, or immaterial damage resulting from the use of, or inability to use, the service|Any consequence arising from a network, server, or software failure",
    disclaimerRisk: "Art. 4 — Assumption of risk. The user acknowledges that the service cannot substitute for a certified or approved counting system. It is the user's responsibility to implement any backup system deemed necessary for critical events.",
    disclaimerPrivacy: "Art. 5 — Data protection. The processing of personal data is carried out in accordance with the Swiss Federal Act on Data Protection (FADP, SR 235.1). Only data strictly necessary for the operation of the service is collected. The user may request the deletion of their account and all associated data at any time.",
    disclaimerLaw: "Art. 6 — Governing law and jurisdiction. These terms are exclusively governed by Swiss law. Any dispute shall be submitted to the competent courts in Switzerland.",
    disclaimerAccept: "I acknowledge having read and accept the General Terms of Use of PartyFlow.ch.",
    disclaimerAcceptBtn: "Accept and continue",
    // Onboarding
    onboardingPlus: "Tap here to count an entry.",
    onboardingMinus: "Tap here to count an exit.",
    onboardingReset: "Resets the counter and deletes all data.",
    onboardingExport: "Export your data as CSV or XLS.",
    onboardingStaffLink: "Copy this link and share it with your team so they can count without an account.",
    onboardingNext: "Next",
    onboardingDone: "Let's go!",
    orContinueWith: "Or continue with",
    phone: "Phone",
    phoneNumber: "Phone number",
    sendCode: "Send code",
    verifyCode: "Verify code",
    otpCode: "Verification code",
    otpSent: "Code sent via SMS",
    otpError: "Error sending code",
    otpInvalid: "Invalid code",
    continueWithGoogle: "Continue with Google",
    continueWithApple: "Continue with Apple",
    offlineBanner: "You are offline",
    offlineBannerDesc: "Data is saved locally",
    backOnline: "Connection restored",
    syncing: "Syncing…",
    syncComplete: "Data synced ✓",
    syncError: "Sync error",
    pendingEntries: "pending entries",
    updateAvailable: "New version available",
    updateNow: "Update now",
  },
} as const;

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations.fr;
